// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/utils/v1/sensitive.proto (package chalk.utils.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file chalk/utils/v1/sensitive.proto.
 */
export const file_chalk_utils_v1_sensitive: GenFile = /*@__PURE__*/
  fileDesc("Ch5jaGFsay91dGlscy92MS9zZW5zaXRpdmUucHJvdG8SDmNoYWxrLnV0aWxzLnYxOkAKCXNlbnNpdGl2ZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYm/QEIAEoCFIJc2Vuc2l0aXZliAEBYgZwcm90bzM", [file_google_protobuf_descriptor]);

/**
 * Indicate that the field value should not be printed out when using debug
 * formats, e.g. when the field contains sensitive credentials.
 * Used instead of google.protobuf.FieldOptions.debug_redact because
 * vcpkg hasn't upgraded to a newer version of protos.
 *
 * @generated from extension: optional bool sensitive = 80411;
 */
export const sensitive: GenExtension<FieldOptions, boolean> = /*@__PURE__*/
  extDesc(file_chalk_utils_v1_sensitive, 0);

